
import React, { useEffect, useState } from 'react'
import { Popup,  ListItem,
    ListContent,
    List,Icon,Accordion,AccordionContent,AccordionTitle } from 'semantic-ui-react'
import InputField from '../../../formComponents/inputField'
import './additionDeductionList.scss'
import { AdditionDeductionSourceMap } from './utils/constants'

 const AdditionDeductionList=({updatedDs={},linkStyle={},onProrateClick=()=>{},type,disabled,displayReadOnlyFields=true})=> {
  
  const {dataSource,label}=AdditionDeductionSourceMap()[type]
  const[updateData,setUpdateData]=useState(updatedDs)
 const isAnyValueExist=React.useMemo(()=>{
    return dataSource.filter(col => {
  const value = updatedDs[col.columnKey];
  return value != null && String(value)?.trim() !== '' && parseFloat(value) !== 0;
});
  },[updatedDs,dataSource])
  const [open, setOpen] = useState(false)
  const [togglePanel,setTogglePanel]=useState(true)
  
  useEffect(()=>{
   if(open){
   setUpdateData(updatedDs)
   }
  },[open])
  
  useEffect(() => {
    if (!open) return
    
    const handleClickOutside = (e) => {
      const popupElement = document.querySelector('.ui.popup.additionDeductionPopup')
      if (popupElement && popupElement.contains(e.target)) {
        return
      }
      
      const triggerElement = e.target.closest('a[style*="position:absolute"]')
      if (triggerElement) {
        return
      }
      
      setOpen(false)
    }
    
    const timeoutId = setTimeout(() => {
      document.addEventListener('mousedown', handleClickOutside)
    }, 100)
    
    return () => {
      clearTimeout(timeoutId)
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [open])
  const renderList=()=>{
   return <List className="addtiondeductionList" divided>
    <div className='additionDeductionPopup-header'>{label}</div>
 {
    dataSource.map(({label: rowLabel,columnKey})=>{
    return(<ListItem key={columnKey} className='additionDeductionPopup-row'>
     <ListContent className='additionDeductionPopup-label'>{rowLabel}</ListContent>
     <ListContent className='additionDeductionPopup-value'>
     <InputField
              id={`${columnKey}`}
              name={`${columnKey}`}
              type='text'
              isInteger={true}
              handleFocus={(e) => e.target.select()}
              isLabel={false}
             value={updateData[columnKey] || ""}
             onChange={(value)=>setUpdateData(prev=>({...prev,[columnKey]:value.replace(/[^\d.-]/g, '')}))}
             onBlur={(value)=>setUpdateData(prev=>({...prev,[columnKey]:parseFloat(value || 0.00).toFixed(2)}))}
             disabled={disabled}
             formDisabled
              subLabelText='$'
              subLabelClass='left-icon'
          />
  
     </ListContent>
   </ListItem>)
    })
}
<div className='actionBtns'>
<button type="button" className="ui button additionDeduction-btn additionDeduction-btn--secondary" onClick={()=>{
  setUpdateData(updatedDs)
  setOpen((prevOpen) => !prevOpen)
}} >Cancel</button>
<button type="button" className="ui button additionDeduction-btn additionDeduction-btn--primary" onClick={()=>{
    const tempData={...updateData}
      const { [type]: totalValue,calculatedDeletions,calculatedAdditions, ...rest } = tempData;
        tempData[type]=Object.values(rest).reduce((sum, val) => sum + parseFloat(val || 0.00),0.00).toFixed(2); 
       
  onProrateClick(tempData)
  setOpen((prevOpen) => !prevOpen)
}} disabled={disabled}>Save & Prorate</button>
</div>
 </List>
  
  }
const displayFieldsIfValuePresent=()=>{
        return (<Accordion fluid styled style={{backgroundColor:'#eff3f7'}}>
        <AccordionTitle active={togglePanel} style={{padding:'.2rem',color:'#4183c4',fontWeight:'500'}} onClick={()=>setTogglePanel(prev=>!prev)} >
          
          <Icon name='dropdown' />
          {`${isAnyValueExist.length} ${label}`}
        </AccordionTitle>
        <AccordionContent active={togglePanel}>
         
<div style={{display:'flex',flexWrap:'wrap',gap:'.3rem'}}>
    {
    
          
            isAnyValueExist.map(({label,columnKey})=>{
               
             return(
              <div key={columnKey} style={{flex:1,minWidth:'45%',position:'relative'}}>
             <InputField 
              id={`${columnKey}`}
              name={`${columnKey}`}
             label={label}
             type={'Number'}
             className="addtionDeductionFields field-bg"
             formDisabled
             subLabelText='$'
             subLabelClass='left-icon'
             value={updatedDs[columnKey] || ""}
             isInteger={true}
             disabled={true}
           
           />
           </div>
            )
            })
          }
    
       </div>
       
        </AccordionContent>
   </Accordion>)
}
    return (
      <div className='addtiondeductionContainer' style={{display:'flex'}}>
       {displayReadOnlyFields && isAnyValueExist.length>0 && displayFieldsIfValuePresent()}
        <Popup
        trigger={<a onClick={()=>setOpen((prevOpen) => !prevOpen)} style={{position:'absolute',right:'3px',top:20,cursor:'pointer',...linkStyle}}><Icon name='plus circle' />{`${isAnyValueExist?.length>0 ? "Edit" :"Add"} ${label}`}</a>}
        content={renderList}
        position='bottom left'
       // style={{padding:"0 !important"}}
        open={open}
        onClose={() => {}} 
        className="additionDeductionPopup"
      />
     
      </div>
    )
  
}

export default AdditionDeductionList
